import axios from 'axios';
import mapStyles from '../map/map-styles';
import markerIcons from '../map/marker-icons-location-page';
import infoWindow from '../map/info-window';

export default () => {
  if(!document.getElementById('building-map-canvas')) return;
  const $map = document.getElementById('building-map-canvas');
  const buildingId = $map.getAttribute('data-id');
  const zoom = $map.getAttribute('data-zoom');
  let map;
  const buildings = {};
  let openedInfoWindowId = -1;
  let hoveredMarker = -1;

  const icons = markerIcons();

  const hoverMarker = id => {
    const marker = buildings[id].marker;
    if (id === +buildingId) {
      marker.setIcon(icons.hovered);
    } else {
      marker.setIcon(icons.hiddenHovered);
      marker.setZIndex(2);
    }
    hoveredMarker = id;
  };

  const unHoverMarker = id => {
    if (openedInfoWindowId === hoveredMarker) return;
    const building = buildings[id];
    if (!building) return;
    const marker = building.marker;
    if (id === +buildingId) {
      marker.setIcon(icons.default);
    } else {
      marker.setIcon(icons.hidden);
      marker.setZIndex(1);
    }
    hoveredMarker = -1;
  };

  const closeInfoWindows = () => {
    const building = buildings[openedInfoWindowId];
    if (!building) return;
    const marker = building.marker;
    if (!marker.infoWindow) return;
    marker.infoWindow.close();
  };

  const initInfoWindow = building => {
    const marker = building.marker;
    closeInfoWindows();
    unHoverMarker(openedInfoWindowId);
    hoverMarker(building.id);
    openedInfoWindowId = building.id;

    const api = 'https://www.google.com/maps/dir/?api=1';
    const destination = building.address;
    const data = {
      name: building.name,
      link: building.link,
      directions: `${api}&&destination=${destination}`,
    };

    marker.infoWindow = new google.maps.InfoWindow(
        {content: infoWindow(data)});
    marker.infoWindow.open(map, marker);
    google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
      hoveredMarker = -1;
      unHoverMarker(openedInfoWindowId);
      openedInfoWindowId = -1;
    });
  };

  const addActionsToMarker = building => {
    const marker = building.marker;
    marker.addListener('click', () => initInfoWindow(building));
    marker.addListener('mouseover', () => hoverMarker(building.id));
    marker.addListener('mouseout', () => unHoverMarker(hoveredMarker));
  };

  const initZoomControl = () => {
    const mapControlIn = document.getElementById('map-control-in');
    const mapControlOut = document.getElementById('map-control-out');
    mapControlIn.onclick = () => {
      map.setZoom(map.getZoom() + 1);
    };
    mapControlOut.onclick = () => {
      map.setZoom(map.getZoom() - 1);
    };
  };

  // init map
  axios.get(window.locationsJSON).then(response => {
    const styledMapType = new google.maps.StyledMapType(mapStyles,
        {name: 'Styled Map'});
    map = new google.maps.Map($map, {disableDefaultUI: true});
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');
    const markerBounds = new google.maps.LatLngBounds();
    response.data.forEach(building => {
      const pos = {lat: +building.lat, lng: +building.lng};
      building.marker = new google.maps.Marker({
        position: pos,
        map: map,
        icon: icons.hidden,
        title: building.name,
      });
      addActionsToMarker(building);
      const point = new google.maps.LatLng(building.lat, building.lng);
      markerBounds.extend(point);
      buildings[building.id] = building;
    });

    if (buildingId) {
      const pos = buildings[buildingId].marker.getPosition();
      const lat = pos.lat();
      const lng = pos.lng();
      const building = buildings[buildingId];
      map.setCenter({lat: lat, lng: lng});
      if (zoom) {
        map.setZoom(+zoom);
      } else {
        map.setZoom(17);
      }
      initInfoWindow(building);
    } else {
      map.fitBounds(markerBounds);
    }

    initZoomControl();

  }).catch(error => console.log(error));
}
